var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgImgFence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 60a54.786 54.786 0 01-16.23 39.01l-.69.68c-.4.389-.81.759-1.22 1.129a53.782 53.782 0 01-6.86 5.28c-.86.56-1.73 1.1-2.62 1.6l-.7.39a55.002 55.002 0 01-52.8.32c-.23-.13-.47-.25-.7-.39-.65-.36-1.3-.73-1.93-1.12-1.23-.76-2.42-1.56-3.58-2.41-.13-.09-.26-.18-.38-.28a48.013 48.013 0 01-3.4-2.72c-.25-.22-.5-.43-.74-.66-.24-.23-.44-.39-.65-.6l-.7-.66a51.236 51.236 0 01-3.05-3.2A55 55 0 11115 60z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.84 100.83A53.869 53.869 0 0190 106.1c-.86.56-1.73 1.1-2.62 1.6a54.992 54.992 0 01-53.5.71c-.89-.48-1.77-1-2.63-1.51-1.23-.76-2.42-1.56-3.58-2.41-1.31-.94-2.57-1.95-3.78-3-.25-.22-.5-.43-.74-.66h73.69z",
    fill: "#D1D1D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 37.61V108c-.65-.36-1.3-.73-1.93-1.12-1.23-.76-2.42-1.56-3.58-2.41-.13-.09-.26-.18-.38-.28a48.013 48.013 0 01-3.4-2.72c-.25-.22-.5-.43-.74-.66-.24-.23-.44-.39-.65-.6l-.7-.66v-62a3.06 3.06 0 013.05-3.06h5.28a3.06 3.06 0 013.05 3.06v.06z",
    fill: "#D87E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.19 51.7h5.99v2.83h-3.41l-2.58-2.83zM27.19 74.47h5.99v2.83h-3.41l-2.58-2.83z",
    fill: "#884600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 37.66v70.341c-.65-.36-1.3-.73-1.93-1.12-1.23-.76-2.42-1.56-3.58-2.41-.13-.09-.26-.18-.38-.28a48.3 48.3 0 01-3.4-2.72c-.25-.22-.5-.43-.74-.66-.24-.23-.44-.39-.65-.6l-.7-.66V86.26a4.07 4.07 0 005.69-2.92 43.455 43.455 0 001.19-6.63c.06-.53.12-1.09.18-1.65.25-2.66.44-5.6.57-8.68.05-.95.08-1.9.11-2.88.1-2.9.15-5.85.17-8.73v-2.82-2.82-6.28-2.44c0-2.16-.08-3.95-.11-5.24a.611.611 0 01.6-.62 3 3 0 012.16.91 3.09 3.09 0 01.82 2.2z",
    fill: "#884600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 52v55.999c-.65-.36-1.3-.73-1.93-1.12-1.23-.76-2.42-1.56-3.58-2.41-.13-.09-.26-.18-.38-.28.193-.766.373-1.566.54-2.4 2.22-10.79 3.31-26.06 3.34-26.73a228.898 228.898 0 00.36-8.68c0-1 0-2 .06-2.88.05-3.56 0-6.61 0-8.68 0-1.8-.07-2.87-.07-2.87l1.66.05z",
    fill: "#5B2A02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.06 37.61V99c-.62.63-1.26 1.231-1.92 1.821a53.869 53.869 0 01-6.84 5.27c-.86.56-1.73 1.1-2.62 1.6v-70.08a3.06 3.06 0 013-3.06H95a3 3 0 012.16.9 3.051 3.051 0 01.9 2.16z",
    fill: "#884600"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.53 40.32H27.19V51.7h64.34V40.32z",
    fill: "#EFB003"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.68 40.32S76.56 51.7 67.18 51.7h24.35V40.32h-4.85z",
    fill: "#D87E00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.21 40.32c-26.25 0-41 10.09-41 10.09V40.32h41z",
    fill: "#FCD222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.53 63.08H27.19v11.38h64.34V63.08z",
    fill: "#EFB003"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.53 63.08H27.19v2.83h64.34v-2.83z",
    fill: "#D87E00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.68 63.08s-10.12 11.39-19.5 11.39h24.35V63.08h-4.85z",
    fill: "#D87E00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.53 40.32V51.7h-6.34l3.51-11.38h2.83z",
    fill: "#280C03"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.53 63.08V64l-.59 1.92-2.64 8.55h-8.65l2.07-6.71.57-1.84.87-2.84h8.37zM77.25 63.08l-.88 2.84-2.64 8.55h-8.65l2.64-8.55.87-2.84h8.66zM82.78 40.32l-1.57 5.09-1.94 6.29h-8.66l.16-.51 3.36-10.87h8.65zM62.67 63.08l-.87 2.84-2.64 8.55h-8.65l2.64-8.55.87-2.84h8.65zM68.21 40.32L64.7 51.7h-8.65l3.39-10.99.12-.39h8.65zM48.1 63.08l-.87 2.84-2.64 8.55h-8.65l2.64-8.55.87-2.84h8.65zM53.64 40.32l-.35 1.14-3.16 10.24h-8.65l2.55-8.29.96-3.09h8.65zM33.53 63.08l-.87 2.84-2.64 8.55h-2.83V63.08h6.34zM39.07 40.32l-1.6 5.18-1.91 6.2h-8.37v-.92l.14-.46 3.09-10h8.65z",
    fill: "#492F15"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.06 37.66v62c-.4.391-.81.761-1.22 1.131a53.876 53.876 0 01-6.84 5.31c-.86.56-1.73 1.1-2.62 1.6l-.7.39v-31.74a4.08 4.08 0 005.69-2.93c2.88-9.93 2.24-29.94 2-38.25a.61.61 0 01.6-.62 3 3 0 012.16.91 3.13 3.13 0 01.93 2.2z",
    fill: "#5B2A02"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.13 56.65l-.06 43v.35-.3c-.4.39-.81.76-1.22 1.13A53.77 53.77 0 0190 106.1c-.86.56-1.73 1.1-2.62 1.6l-.7.39V97.31c8.6-5.13 10.76-24.78 11.38-38.91.03-.59.05-1.18.07-1.75z",
    fill: "#280C03"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.06 66.71v-15s.32 6.59 0 15z",
    fill: "#280C03"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.53 51.7h-4.85v2.83h4.85V51.7zM91.53 74.47h-4.85v2.83h4.85v-2.83z",
    fill: "#5B2A02"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.07 40.32l-1.6 5.18a51.81 51.81 0 00-10.14 4.82l3.09-10h8.65zM45 40.32h8.65l-.35 1.14a88.367 88.367 0 00-9.3 1.95l1-3.09zM68.21 40.32c-3.09 0-6 .14-8.77.39l.12-.39h8.65z",
    fill: "#685937"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.21 45.41l-1.94 6.29h-8.65l.15-.51a30.43 30.43 0 0010.44-5.78zM27.19 63.08h6.34l-.87 2.84h-5.47v-2.84zM39.45 63.08h8.65l-.87 2.84h-8.65l.87-2.84zM54.02 63.08h8.65l-.87 2.84h-8.65l.87-2.84zM68.59 63.08h8.66l-.88 2.84h-8.65l.87-2.84zM91.53 63.08V64l-.59 1.92h-8.65l.87-2.84h8.37z",
    fill: "#280C03"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.53 63.08V64l-.59 1.92-2.64 8.55h-8.65l2.07-6.71c.79-.65 1.5-1.28 2.12-1.84 1.77-1.63 2.84-2.84 2.84-2.84h4.85z",
    fill: "#280C03"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.72 34.55s-3.78 1.22-4.92 24V37.61a3.05 3.05 0 013.05-3.06h1.87z",
    fill: "#EFB003"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.12 28.094l4.885 4.886M60 24v8.98M69.88 28.094l-4.886 4.886",
    stroke: "#0B5FEF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgImgFence;